module.exports = new __parcel__URL__("right-arrow.e26353de.svg").toString();